(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2607],{

/***/ 32607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Brands; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/styleguide/Carousel/index.ts + 1 modules
var Carousel = __webpack_require__(46118);
// EXTERNAL MODULE: ./components/styleguide/Homepage/Sections/Brands/brands.module.scss
var brands_module = __webpack_require__(66118);
var brands_module_default = /*#__PURE__*/__webpack_require__.n(brands_module);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/filters.js
var filters = __webpack_require__(46850);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
;// CONCATENATED MODULE: ./components/styleguide/Homepage/Sections/Brands/Brands.tsx








var Brands = function(param) {
    var isVans = param.isVans;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
            children: "Brands A-Z"
        }),
        scrollValue: 493,
        moreLink: isVans ? "van-leasing/search" : "car-leasing/search",
        moreLabel: "brands",
        sectionName: "brands",
        children: filters/* FILTERS.manufacturers.filter */.O.manufacturers.filter(function(m) {
            var type = isVans ? constants/* FILTER_VEHICLE_TYPES_VANS */.Bz : constants/* FILTER_VEHICLE_TYPES_CARS */.DC;
            return m.vehicleTypes.includes(type);
        }).map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/".concat(isVans ? "van" : "car", "-leasing/").concat((0,vehicle/* getUrlReadyString */.oh)(item.name)),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: (brands_module_default()).link,
                    "data-name": item.name.toLowerCase(),
                    "data-needs-white": item.name !== "Ford",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (brands_module_default()).image,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/manufacturer-logos/symbol-only/").concat((0,vehicle/* getUrlReadyString */.oh)(item.name), ".png"),
                                alt: item.name,
                                height: 56,
                                width: 56
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (brands_module_default()).label,
                            children: item.name
                        })
                    ]
                })
            }, item.name);
        })
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Homepage/Sections/Brands/index.ts



/***/ }),

/***/ 66118:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"brands_link__anT1i","label":"brands_label__tgyQM","image":"brands_image__xTk2L","spacer":"brands_spacer__6wQKx","phAnimation":"brands_phAnimation__jaRr5"};

/***/ })

}]);